import { parseJwt } from "./token.util.ts";

export function isCreator(userId: string): boolean {
  const token = localStorage.getItem("token");
  if (!token) return true;
  const decoded = parseJwt(token);
  return decoded?.usuarioId === userId;
}
